import { Menu, MenuProps, styled } from '@mui/material';
import React from 'react';
import { labelFontSemiBold, vars } from '../../../Theme';

/**
 * Stylised Context Menu.
 */
export default styled((props: MenuProps) => <Menu {...props} />)(({ theme }) => ({
    '& .MuiPaper-root': {
        boxShadow: '1px 1px 4px 2px rgba(0, 0, 0, 0.25);',
        marginTop: theme.spacing(0.5),
        color: vars.font,
        minWidth: 180,

        '& .MuiDivider-root': {
            margin: '0 12px',
        },

        '& .MuiMenuItem-root': {
            ...labelFontSemiBold,
            lineHeight: '40px',
            padding: '0 12px',
            fontSize: '16px',

            '&:active': {
                backgroundColor: vars.fillGray,
            },
        },
    },
}));
